import axios from "axios";
import { API_URL, getHeaders } from "../config";

// Function to handle logout and redirect
const handleLogout = () => {
  localStorage.removeItem("token");
  window.location.href = "/"; // Directly use string, no need for parentheses around it
};

// Function to get assessment by ID
export const getAssessment = async (id, moduleType) => {
  try {
    const { data } = await axios.get(`${API_URL}/api/assessment?id=${id}&moduleType=${moduleType}`, {
      headers: getHeaders().headers,
    });
    return data || {}; // Ensure data is always returned, even if undefined
  } catch (error) {
    const status = error?.response?.status;
    if (!status) return { error }; // Handle cases where status may not exist

    if (status === 401 || status === 403) {
      handleLogout(); // Log out if unauthorized
    }
    return { error }; // Return error for other cases
  }
};

export const getIntranetAssessment = async (id, moduleType) => {
  try {
    const { data } = await axios.get(`${API_URL}/api/assessment/intranet?id=${id}&moduleType=${moduleType}`, {
      headers: getHeaders().headers,
    });
    return data || {}; // Ensure data is always returned, even if undefined
  } catch (error) {
    const status = error?.response?.status;
    if (!status) return { error }; // Handle cases where status may not exist

    if (status === 401 || status === 403) {
      handleLogout(); // Log out if unauthorized
    }
    return { error }; // Return error for other cases
  }
};

export const getWarmup = async (id) => {
  try {
    const { data } = await axios.get(
      `${API_URL}/api/assessment/warmup?id=${id}`,
      {
        headers: getHeaders().headers,
      }
    );
    return data || {}; // Ensure data is always returned, even if undefined
  } catch (error) {
    const status = error?.response?.status;
    if (!status) return { error }; // Handle cases where status may not exist

    if (status === 401 || status === 403) {
      handleLogout(); // Log out if unauthorized
    }
    return { error }; // Return error for other cases
  }
};

// Function to submit answers for assessment
export const submitAnswers = async (submissionData) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/assessment/submitAssessment`,
      submissionData,
      { headers: getHeaders().headers }
    );
    return { success: true, data: response.data };
  } catch (error) {
    const status = error?.response?.status;
    // Surfaced so the learner sees why, not a generic failure.
    const message = error?.response?.data?.message;

    if (!status) return { error, message }; // Handle cases where status may not exist

    if (status === 401 || status === 403) {
      handleLogout(); // Log out if unauthorized
    }
    return { error, message }; // Return error for other cases
  }
};
export const getAnswers = async () => {
  try {
    const response = await axios.get(`${API_URL}/api/assessment/getAnswer`, {
      headers: getHeaders().headers,
    });
    return { success: true, data: response.data };
  } catch (error) {
    const status = error?.response?.status;
    if (!status) return { error }; // Handle cases where status may not exist

    if (status === 401 || status === 403) {
      handleLogout(); // Log out if unauthorized
    }
    return { error }; // Return error for other cases
  }
};

// Save in-progress answers so the learner can resume later. Best-effort: a
// failed autosave should not interrupt the assessment, so callers just get
// back an error flag rather than a thrown exception.
export const saveProgress = async (assessmentId, responses, currentQuestionIndex) => {
  try {
    await axios.post(
      `${API_URL}/api/assessment/saveProgress`,
      { assessmentId, responses, currentQuestionIndex },
      { headers: getHeaders().headers }
    );
    return { success: true };
  } catch (error) {
    const status = error?.response?.status;
    if (status === 401 || status === 403) {
      handleLogout();
    }
    return { error };
  }
};

// Fetch a previously saved draft, if any, to resume an in-progress attempt.
export const getProgress = async (assessmentId) => {
  try {
    const { data } = await axios.get(
      `${API_URL}/api/assessment/progress?assessmentId=${assessmentId}`,
      { headers: getHeaders().headers }
    );
    return data || { responses: {}, currentQuestionIndex: 0 };
  } catch (error) {
    const status = error?.response?.status;
    if (status === 401 || status === 403) {
      handleLogout();
    }
    return { responses: {}, currentQuestionIndex: 0, error };
  }
};

export const getAllWarmUp = async () => {
  try {
    const { data } = await axios.get(`${API_URL}/api/assessment/warmup/all`, {
      headers: getHeaders().headers,
    });
    if (data) {
      return data;
    }
    return data; // Add a return for other response cases if needed
  } catch (error) {
    const axiosError = error; // Cast error as AxiosError
    const status = axiosError.response?.status;

    if (!status) return { error: axiosError }; // Handle cases where status may not exist

    if (status === 401 || status === 403) {
      handleLogout(); // Log out if unauthorized
    }

    return { error: axiosError }; // Return error for other cases
  }
};
